// extracted by mini-css-extract-plugin
export var connectWalletButton = "ConnectWalletButton-module--connectWalletButton--94bfd";